import { request } from './utils';
import { formatUSDateToISO } from './../utils/formatters';

export default class PullHistoryService {
    static async getLatestPullHistoryByDate(date) {
        const formattedDate = formatUSDateToISO(date);
        const response = await request(`/api/daily_automation_history/latest?date=${encodeURIComponent(formattedDate)}`);
        return response;
    }

    static async getPullHistoryByDate(date) {
        const formattedDate = formatUSDateToISO(date);
        const response = await request(`/api/daily_automation_history?date=${encodeURIComponent(formattedDate)}`);
        return response;
    }

    static async getPullHistoryByID(id) {
        const response = await request(`/api/daily_automation_history/${id}`);
        return response;
    }
}
